import { useState } from 'react';

// This form only captures the customer's phone. Its parent sends the request
// through the consultation agent, which remains responsible for the funnel.
export default function WaitlistForm({ onSubmit, disabled = false }) {
  const [phone, setPhone] = useState('');

  const submit = (event) => {
    event.preventDefault();
    const value = phone.trim();
    if (!value || disabled) return;
    onSubmit(value);
    setPhone('');
  };

  return (
    <form className="waitlist-form" onSubmit={submit} aria-label="فرم پیش‌ثبت‌نام فیبر نوری">
      <label className="waitlist-label" htmlFor="consult-waitlist-phone">
        شماره همراه برای پیش‌ثبت‌نام
      </label>
      <div className="waitlist-controls">
        <input
          id="consult-waitlist-phone"
          name="phone"
          type="tel"
          dir="ltr"
          inputMode="numeric"
          autoComplete="tel"
          placeholder="۰۹۱۲۳۴۵۶۷۸۹"
          value={phone}
          onChange={(event) => setPhone(event.target.value)}
          aria-label="شماره همراه برای پیش‌ثبت‌نام"
          disabled={disabled}
          required
        />
        <button className="waitlist-submit-btn" type="submit" disabled={disabled || !phone.trim()}>
          ثبت پیش‌ثبت‌نام
        </button>
      </div>
    </form>
  );
}
